// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Slider{border-radius:.375rem;margin-bottom:1.5rem;overflow:hidden}@media(min-width:768px){.Slider{margin-bottom:2.5rem;margin-top:.5rem}}.Slider__image{border-radius:.375rem}@media(min-width:768px){.Slider__circleTabs{left:4rem;transform:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
